import { render } from "./Ai.vue?vue&type=template&id=77aa98d7"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"

import "./Ai.vue?vue&type=style&index=0&id=77aa98d7&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__